<template>
    <div class="business-content-main add-accessories" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="section">
            <div class="left">
                <div class="btns">
                    <el-button size="small" class="search-btn" type="warning" icon="el-icon-upload" :disabled="saveBtndisabled" @click="submitConfirm"
                        >提交保存</el-button
                    >
                    <el-button size="small" class="search-btn" type="primary" @click="showGoodImgRsDialog">共享图片</el-button>
                </div>
                <div class="form-main">
                    <el-form :rules="rules" :model="partData" ref="partData" label-width="80px" class="form-ctn">
                        <div class="form-main">
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="汽配名称" prop="GoodName">
                                        <el-autocomplete
                                            class="search-item"
                                            size="medium"
                                            v-model="partData.GoodName"
                                            :fetch-suggestions="searchGoodName"
                                            :debounce="500"
                                            placeholder="请输入配件名称"
                                            :trigger-on-focus="false"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="英文名称" prop="ExAttribute4">
                                        <el-input v-model="partData.ExAttribute4" class="search-item" size="medium"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="库存数" prop="Inventory" suffix-icon="iconfont icon-sousuo">
                                        <el-input-number
                                            type="number"
                                            v-model="partData.Inventory"
                                            class="search-item"
                                            style="width: 200px"
                                            size="medium"
                                            :disabled="invenCanNotBeEdit"
                                            @change="invenChange"
                                        ></el-input-number>
                                        <span class="invTip">存放在仓位下的商品总数：{{ warehousedCount }}</span>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="汽配编码" prop="APCode">
                                        <div style="width: 200px; display: flex; flex-direction: column; align-content: center; text-align: center">
                                            <el-input class="search-item" size="medium" v-model="partData.APCode" @change="getAutoSeriesByApCode"></el-input>
                                            <span class="invTip">为了更好地进行车型匹配，请用原厂编码</span>
                                        </div>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="汽配品牌" prop="Brand">
                                        <el-autocomplete
                                            style="width: 200px"
                                            clearable
                                            popper-class="autocomplete"
                                            v-model.trim="partData.Brand"
                                            :fetch-suggestions="searchBrand"
                                            value-key="Text"
                                            size="medium"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="预警上限" prop="ExAttribute2">
                                        <el-input-number
                                            style="width: 200px"
                                            type="number"
                                            v-model="partData.ExAttribute2"
                                            class="search-item"
                                            size="medium"
                                            :min="0"
                                        ></el-input-number>
                                    </el-form-item>
                                </div>
                                <div class="form-item price-point">
                                    <el-form-item label="单位" prop="Unit">
                                        <el-autocomplete
                                            style="width: 200px"
                                            clearable
                                            popper-class="autocomplete"
                                            v-model.trim="partData.Unit"
                                            :fetch-suggestions="searchUnit"
                                            value-key="Value"
                                            size="medium"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </div>
                                <div class="form-item price-point">
                                    <el-form-item label="汽配分类" prop="ExAttribute1">
                                        <el-select
                                            class="cate-select search-item"
                                            v-model="partData.ExAttribute1"
                                            filterable
                                            clearable
                                            remote
                                            reserve-keyword
                                            allow-create
                                            size="small"
                                            :remote-method="searchCate"
                                            v-select-scroll-more="searchCateLoad"
                                            @visible-change="cateVisibleChange($event)"
                                            @clear="cateClearHandle"
                                            placeholder="请输入汽配分类"
                                        >
                                            <el-option v-for="optionItem in apCategoryList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                                <div class="option-content">
                                                    <div>{{ optionItem.Text }}</div>
                                                </div>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-item price-point">
                                    <el-form-item label="预警下限" prop="ExAttribute3">
                                        <el-input-number
                                            style="width: 200px"
                                            type="number"
                                            v-model="partData.ExAttribute3"
                                            class="search-item"
                                            size="medium"
                                            :min="0"
                                        ></el-input-number>
                                        <span class="invTip" @click="showLimitSet">点击快速设置各仓上下限</span>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line price-point">
                                <div class="form-item" style="display: flex; flex-wrap: wrap; width: 100%">
                                    <div style="display: flex; align-items: center">
                                        <el-form-item label="成本价" prop="CostPrice">
                                            <div style="display: flex; align-items: center">
                                                <el-input
                                                    type="number"
                                                    step="0.01"
                                                    v-model="partData.CostPrice"
                                                    class="search-item"
                                                    style="width: 150px"
                                                    size="medium"
                                                    @input="onCostPriceInput"
                                                    :min="0"
                                                >
                                                    <template slot="append">¥</template></el-input
                                                >
                                                <div style="height: 40px; width: 60px; padding-left: 25px">✖&nbsp;</div>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div>
                                        <div style="display: flex; flex-wrap: wrap; width: 100%">
                                            <el-form-item label-width="50px" label="点数" prop="PricePoint">
                                                <div style="display: flex; align-items: center">
                                                    <el-input
                                                        type="number"
                                                        :step="0.1"
                                                        v-model="partData.PricePoint"
                                                        :min="0"
                                                        size="mini"
                                                        style="width: 70px"
                                                        @change="onPricePiontChange"
                                                        oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                                    ></el-input>
                                                    <el-button v-show="isStopAutoCalc" size="small" class="calc-btn" @click="calcPrice"
                                                        ><i class="fa fa-calculator"></i
                                                    ></el-button>
                                                    <div style="height: 40px; width: auto; padding-left: 10px">&nbsp;=</div>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label-width="80px" label="批发价" prop="Price">
                                                <div style="display: flex; align-items: center">
                                                    <el-input
                                                        type="number"
                                                        step="0.01"
                                                        v-model="partData.Price"
                                                        class="search-item"
                                                        style="width: 150px"
                                                        size="medium"
                                                        :min="0"
                                                        @change="onPriceChange"
                                                    >
                                                        <template slot="append">¥</template></el-input
                                                    >
                                                    <el-checkbox style="padding-left: 10px" v-model="isRoundNum1" :checked="isRoundNum1" @change="onIsCeilNumChange1"
                                                        >价格取整</el-checkbox
                                                    >
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div style="display: flex; flex-wrap: wrap; width: 100%">
                                            <el-form-item label-width="50px" label="点数" prop="MarketPricePoint">
                                                <div style="display: flex; align-items: center">
                                                    <el-input
                                                        type="number"
                                                        :step="0.1"
                                                        v-model="partData.MarketPricePoint"
                                                        :min="0"
                                                        size="mini"
                                                        style="width: 70px"
                                                        @change="onMarketPPChange"
                                                        oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                                    ></el-input>
                                                    <el-button v-show="isStopAutoCalc" size="small" class="calc-btn" @click="calcMarketPrice"
                                                        ><i class="fa fa-calculator"></i
                                                    ></el-button>
                                                    <div style="height: 40px; width: auto; padding-left: 10px">&nbsp;=</div>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label-width="80px" label="零售价" prop="MarketPrice">
                                                <div style="display: flex; align-items: center">
                                                    <el-input
                                                        type="number"
                                                        step="0.01"
                                                        v-model="partData.MarketPrice"
                                                        class="search-item"
                                                        size="medium"
                                                        style="width: 150px"
                                                        :min="0"
                                                        @change="onMarketPriceChange"
                                                    >
                                                        <template slot="append">¥</template></el-input
                                                    >
                                                    <el-checkbox style="padding-left: 10px" v-model="isRoundNum2" :checked="isRoundNum2" @change="onIsCeilNumChange2"
                                                        >价格取整</el-checkbox
                                                    >
                                                </div>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="材质" prop="Texture">
                                        <el-input v-model="partData.Texture" class="search-item" size="medium"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="颜色" prop="Color">
                                        <el-input v-model="partData.Color" class="search-item" size="medium"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="产地">
                                        <el-select
                                            class="search-item"
                                            size="small"
                                            v-model="partData.Origin"
                                            remote
                                            filterable
                                            allow-create
                                            clearable
                                            :remote-method="searchOrigin"
                                            v-select-scroll-more="searchOriginLoad"
                                            popper-class="my-select"
                                            placeholder="请输入产地"
                                        >
                                            <el-option v-for="item in originOptions" :key="item" :label="item" :value="item"> </el-option>
                                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                                加载中
                                                <i class="el-icon-loading"></i>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="配件尺寸" prop="Size">
                                        <el-input v-model="partData.Size" class="search-item" size="medium"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="装箱规格" prop="PackingNum">
                                        <el-input v-model="partData.PackingNum" class="search-item" size="medium" placeholder="整箱商品的数量：/箱，/个，/盒…"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="重量" prop="Quality">
                                        <el-input type="number" step="0.01" v-model="partData.Quality" class="search-item" size="medium" :min="0">
                                            <template slot="append">kg</template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item" style="width: 62.66%">
                                    <el-form-item label="包装尺寸" class="packageSize">
                                        长
                                        <input
                                            v-model.number="partData.Length"
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            size="small"
                                            oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                            @blur="inputBlur"
                                            @focus="inputFocus"
                                        />
                                        &nbsp;宽
                                        <input
                                            v-model.number="partData.Width"
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            size="small"
                                            oninput="this.value=this.value.replace(!/^\d+(.\d{0,2})?$/, '');"
                                            @blur="inputBlur"
                                            @focus="inputFocus"
                                        />
                                        &nbsp;高
                                        <input
                                            v-model.number="partData.Height"
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            size="small"
                                            oninput="this.value=this.value.replace(!/^\d+(\.\d{0,2})?$/, '');"
                                            @blur="inputBlur"
                                            @focus="inputFocus"
                                        />
                                        (cm)
                                    </el-form-item>
                                </div>
                                <div class="form-item" v-if="isShowPerf">
                                    <el-form-item label="绩效属性" prop="PerfSetId">
                                        <el-select
                                            class="cate-select search-item"
                                            v-model="partData.PerfSetId"
                                            filterable
                                            clearable
                                            remote
                                            reserve-keyword
                                            size="small"
                                            @visible-change="perfVisibleChange"
                                        >
                                            <el-option
                                                v-for="optionItem in perfSetList"
                                                :key="optionItem.LevelId"
                                                :label="optionItem.LevelName"
                                                :value="optionItem.LevelId"
                                            >
                                                <span style="float: left">{{ optionItem.LevelName }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">（{{ optionItem.EarnPoint }}）</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item" style="width: 30%">
                                    <el-form-item label="主要图片">
                                        <uploadFile
                                            ref="uploadMainFile"
                                            type="EntpTempGoods"
                                            :limit="1"
                                            :initfileList="partData.MainImg ? [partData.MainImg] : []"
                                            @uploadSuccess="uploadMainSuccess"
                                            @handleRemove="handleMainRemove"
                                            :wText="watermarkText"
                                        ></uploadFile>
                                    </el-form-item>
                                </div>
                                <div class="form-item" style="width: 65%">
                                    <el-form-item label="辅助图片">
                                        <uploadFile
                                            ref="uploadMinorFile"
                                            type="EntpTempGoods"
                                            :multiple="true"
                                            :initfileList="uploadPictureList"
                                            @uploadSuccess="uploadMinorSuccess"
                                            @handleRemove="handleMinorRemove"
                                        ></uploadFile>
                                    </el-form-item>
                                </div>
                            </div>
                            <template v-if="isShowAutoSeriseEng">
                                <div class="form-line">
                                    <div class="form-item" style="width: 63%">
                                        <el-form-item label="英文车型">
                                            <el-input v-model="partData.ExAttribute6" class="search-item" size="medium"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-item" style="width: 30%" v-if="isShowProject">
                                        <el-form-item label="合作项目" prop="ProjectId">
                                            <el-select
                                                class="cate-select search-item"
                                                v-model="partData.ProjectId"
                                                filterable
                                                clearable
                                                remote
                                                reserve-keyword
                                                size="small"
                                                @visible-change="projectVisibleChange"
                                            >
                                                <el-option
                                                    v-for="optionItem in projectList"
                                                    :key="optionItem.ProjectId"
                                                    :label="optionItem.ProjectName"
                                                    :value="optionItem.ProjectId"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-line">
                                    <div class="form-item" style="width: 63%">
                                        <el-form-item label="自定义属性">
                                            <div v-for="(item, index) in selfData" :key="index">
                                                <el-input class="search-item" size="medium" v-model="item.key" placeholder="请输入名称"></el-input>
                                                <span style="margin: 0 16px">:</span>
                                                <el-input class="search-item" size="medium" v-model="item.value" placeholder="请输入值"></el-input>
                                                <img
                                                    style="margin-left: 16px"
                                                    @click="delSelfData(index)"
                                                    v-if="selfData.length !== index + 1"
                                                    src="../../../assets/images/del.png"
                                                />
                                                <img
                                                    style="margin-left: 16px"
                                                    @click="addSelfData(index)"
                                                    v-if="selfData.length === index + 1"
                                                    src="../../../assets/images/add.png"
                                                />
                                            </div>
                                        </el-form-item>
                                    </div>
                                </div>
                            </template>
                            <div class="form-line" v-else>
                                <div class="form-item" style="width: 63%">
                                    <el-form-item label="自定义属性">
                                        <div v-for="(item, index) in selfData" :key="index">
                                            <el-input class="search-item" size="medium" v-model="item.key" placeholder="请输入名称"></el-input>
                                            <span style="margin: 0 16px">:</span>
                                            <el-input class="search-item" size="medium" v-model="item.value" placeholder="请输入值"></el-input>
                                            <img
                                                style="margin-left: 16px"
                                                @click="delSelfData(index)"
                                                v-if="selfData.length !== index + 1"
                                                src="../../../assets/images/del.png"
                                            />
                                            <img
                                                style="margin-left: 16px"
                                                @click="addSelfData(index)"
                                                v-if="selfData.length === index + 1"
                                                src="../../../assets/images/add.png"
                                            />
                                        </div>
                                    </el-form-item>
                                </div>
                                <div class="form-item" style="width: 30%" v-if="isShowProject">
                                    <el-form-item label="合作项目" prop="ProjectId">
                                        <el-select
                                            class="cate-select search-item"
                                            v-model="partData.ProjectId"
                                            filterable
                                            clearable
                                            remote
                                            reserve-keyword
                                            size="small"
                                            @visible-change="projectVisibleChange"
                                        >
                                            <el-option
                                                v-for="optionItem in projectList"
                                                :key="optionItem.ProjectId"
                                                :label="optionItem.ProjectName"
                                                :value="optionItem.ProjectId"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="middle" :style="{ height: boxMinHeight }">
                <div class="title">
                    汽配互换码
                    <el-button size="small" class="search-btn btn-primary" @click="changeCodeMatchDialog">智能匹配</el-button>
                </div>
                <el-input
                    class="input-textarea"
                    type="textarea"
                    placeholder="输入请用回车隔行分开，如复制粘贴进来的格式必须带（半角 ',' 或全角逗号 '，'）才会自动转化成标准的回车格式"
                    v-model="enterGoodCode"
                    @paste.native.capture.prevent="handlePaste"
                    @change="getWatermarkText()"
                ></el-input>
            </div>
            <div id="right" class="right">
                <div class="car-type">
                    <div class="label"><span style="color: #f56c6c">*</span>适用车型</div>
                    <el-autocomplete
                        class="search-item"
                        size="medium"
                        :debounce="500"
                        v-model="partData.AutoSerise"
                        :fetch-suggestions="searchAutoSerise"
                        placeholder="请输入车型"
                        :trigger-on-focus="false"
                        @change="getWatermarkText()"
                    ></el-autocomplete>
                </div>
                <div class="row-table" style="margin-bottom: 24px">
                    <div class="row-head">
                        <span>选择的车型</span>
                        <el-button size="small" class="search-btn btn-primary" @click="selectCarType">选择车型</el-button>
                        <el-checkbox
                            v-model="partData.AllModels"
                            @change="allModelsChange"
                            label="全车型"
                            border=""
                            size="small"
                            style="background-color: #fff; margin-left: 10px"
                        ></el-checkbox>
                    </div>
                    <div class="row-body">
                        <!-- 弹框内选择车型后渲染的数据 -->
                        <div class="row-td" v-for="(item, index) in dialogCheckList" :key="index">
                            <i class="el-icon-delete" @click="deleteCarTypeActive(1, index, item)"></i>
                            <div class="row-model">
                                <el-tooltip effect="dark" :content="item.ModelDesc" placement="bottom">
                                    <span>{{ item.ModelDesc }}</span>
                                </el-tooltip>
                            </div>
                        </div>
                        <!-- 智能匹配选择车型后渲染的数据 -->
                        <div class="row-td" v-for="(item, index) in brainCheckList" :key="item.AutoSerieId">
                            <i class="el-icon-delete" @click="deleteCarTypeActive(2, index, item)"></i>
                            <div class="row-model">
                                <el-tooltip effect="dark" :content="item.ModelDesc" placement="bottom">
                                    <span>{{ item.ModelDesc }}</span>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="no-data" v-if="activeNoData">暂无数据</div>
                    </div>
                </div>
                <div class="row-table">
                    <div class="row-head">
                        <span>智能匹配到的车型</span>
                        <el-select v-model="checkedSelect" size="small" @change="changeSelectList">
                            <el-option
                                v-for="optionItem in checkSelectOptions"
                                :label="optionItem.Brand"
                                :key="optionItem.BrandId"
                                :value="optionItem.BrandId"
                            ></el-option>
                        </el-select>
                        <el-button size="small" class="search-btn btn-primary" @click="selectAllHandle">{{ selectAllText }}</el-button>
                    </div>
                    <div class="row-body">
                        <el-checkbox-group v-model="checkedCurrentList">
                            <el-checkbox
                                v-for="(item, index) in checkCurrentOptions"
                                :key="index"
                                class="checkbox-item"
                                :label="item"
                                @change="changeCheckBox($event, item, index)"
                                >{{ item.ModelDesc }}</el-checkbox
                            >
                        </el-checkbox-group>
                        <div class="no-data" v-if="carTypeNoData">暂无数据</div>
                    </div>
                </div>
            </div>
        </div>
        <!--    车型选择   :clearOptions="dialogClearOptions" -->
        <el-dialog title="选择车系" :close-on-click-modal="false" :visible.sync="dialogVisible" :close-on-press-escape="false" width="1380px">
            <selectSeries ref="selectSearise" :visible="dialogVisible" :selectOptions="dialogCheckList" :showSets="true" @confirmButton="confirmSeriesButton" />
        </el-dialog>
        <!--    快速存放商品    -->
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="快速存放商品"
            :visible.sync="storeVisible"
            width="1000px"
            append-to-body
            :before-close="closeStoreDialog"
        >
            <div v-if="storeVisible">
                <storeInventoryGoods :autopartItem="partData" @closeDialog="closeStoreDialog"></storeInventoryGoods>
            </div>
        </el-dialog>
        <!--    关联商品图片    -->
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="关联图片"
            :visible.sync="goodImgRsVisible"
            width="1000px"
            append-to-body
            :before-close="closeGoodImgRsDialog"
        >
            <div v-if="goodImgRsVisible">
                <goodsImgRs :PictureList="uploadPictureList" :GoodsId="partData.EntpTempGoodsId" @closeDialog="closeGoodImgRsDialog" @setImgRs="upImg"></goodsImgRs>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="互换码智能匹配车型" :visible.sync="changeCodeMatchVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="changeCodeMatchVisible">
                <matchAutoSeries :changeCode="enterGoodCode" @closeDialog="confirmSeriesButton"></matchAutoSeries>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="各仓上下限设置" :visible.sync="limitSetVisible" append-to-body width="700px">
            <div class="dialog-content" v-if="limitSetVisible">
                <goodsLimitSet :GoodsId="partData.EntpTempGoodsId" @closeDialog="limitSetClose"></goodsLimitSet>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import selectSeries from '@/components/business/goods/selectSeries';
import uploadFile from '@/components/common/uploadBtn';
import goodsImgRs from '@/components/business/goods/goodsImgRs';
import storeInventoryGoods from '@/components/business/goods/storeInventoryGoods';
import matchAutoSeries from '@/components/business/goods/matchAutoSeries';
import goodsLimitSet from '@/components/business/goods/goodsLimitSet';
export default {
    name: 'AddAccessories',
    components: {
        breadcrumb,
        selectSeries,
        uploadFile,
        goodsImgRs,
        storeInventoryGoods,
        matchAutoSeries,
        goodsLimitSet
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let checkAPCode = (rule, value, callback) => {
            if (!this.partData.EntpTempGoodsId) {
                this.checkAPCode()
                    .then(() => {
                        return callback(new Error('已存在相同的商品'));
                    })
                    .catch(() => {
                        callback();
                    });
            } else {
                callback();
            }
        };
        let checkexAttribute3 = (rule, value, callback) => {
            this.checkexAttribute3()
                .then(result => {
                    if (!result) {
                        return callback(new Error('预警下限不得高于预警上限'));
                    } else {
                        callback();
                    }
                })
                .catch(() => {
                    callback();
                });
        };
        return {
            limitSetVisible: false,
            pageTitle: '',
            needConfirm: true,
            saveBtndisabled: false, //保存按钮是否禁用
            storeVisible: false,
            goodImgRsVisible: false,
            isCheckCode: true,
            partData: {
                EntpTempGoodsId: '',
                GoodName: '',
                GoodCode: '',
                GoodDesc: '',
                MainImg: '',
                Price: 0,
                MarketPrice: 0,
                CostPrice: 0,
                APId: '',
                APCode: '',
                Size: '',
                Quality: '',
                Brand: '',
                Origin: '',
                Color: '',
                Texture: '',
                Unit: '',
                Inventory: 0,
                ExAttribute1: '',
                ExAttribute2: 100,
                ExAttribute3: 0,
                ExAttribute4: '',
                ExAttribute6: '',
                AutoSerise: '',
                PackageSize: '',
                PackingNum: '',
                PictureList: [],
                Length: 0,
                Width: 0,
                Height: 0,
                AllModels: false,
                PricePoint: 1.0,
                MarketPricePoint: 1.0,
                PerfSetId: '',
                ProjectId: '',
                LimitSets: []
            },
            selfData: [
                // 自定义属性
                {
                    key: '',
                    value: ''
                }
            ],
            enterGoodCode: '',
            loading: false,
            isRoundNum1: false,
            isRoundNum2: false,
            uploadPictureList: [],
            inventoryCount: 0, //这个参数是用来判断是否有增加了库存，需要提醒去存放货物
            unInInventory: 0,
            minInventory: 0,
            warehousedCount: 0, //已入库数量
            brandList: [],
            unitList: [],
            apCategoryList: [],
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            rules: {
                APCode: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkAPCode, trigger: 'blur' }
                ],
                APId: [{ required: true, message: '该项必填', trigger: 'change' }],
                GoodName: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Brand: [{ required: true, message: '该项必填', trigger: 'change' }],
                PictureList: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Price: [
                    { validator: checkPositive, trigger: 'blur' },
                    { required: true, message: '该项必填', trigger: 'blur' }
                ],
                MarketPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                CostPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                Quality: [{ required: false, validator: checkPositive, trigger: 'blur' }],
                Unit: [{ required: true, message: '该项必填', trigger: 'change' }],
                ExAttribute1: [{ required: true, message: '该项必填', trigger: 'change' }],
                Inventory: [{ required: false, validator: checkPositive, trigger: 'blur' }],
                AutoSerise: [{ required: true, message: '该项必填', trigger: 'change' }],
                ExAttribute3: [{ validator: checkexAttribute3, trigger: 'blur' }],
                PerfSetId: [{ required: true, message: '该项必填', trigger: 'blur' }],
                ProjectId: [{ required: true, message: '该项必填', trigger: 'blur' }]
            },
            invenCanNotBeEdit: true,
            perfSetList: [],
            projectList: [],
            // 弹框车型已选项
            dialogCheckList: [],
            // 智能车型已选项
            brainCheckList: [],
            // 智能车型-当前下拉框选中项 string BrandId
            checkedSelect: '',
            // 智能车型-下拉框列表 Array
            checkSelectOptions: [],
            // 智能车型-当前展示的列表 Array
            checkCurrentOptions: [],
            // 智能车型-将接口返回的数据缓存这里 Array
            checkAllOptions: [],
            // 智能车型-当前展示列表的已选项 Array
            checkedCurrentList: [],
            // 智能车型-所有列表的已选项-以BrandId为键名 Object
            checkedAllList: {},
            // 车型弹框显隐
            dialogVisible: false,
            // 被删除的车型
            // dialogClearOptions: [],
            //互换码智能匹配弹窗
            changeCodeMatchVisible: false,
            // 页面内容最小高度
            boxMinHeight: 'auto',
            optionLoading: false,
            goodNameOptions: [],
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            originOptions: [],
            originForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            sptpsy: false, //商品图片添加水印
            watermarkText: '', //水印内容
            isShowPerf: false, //是否展示绩效属性
            isCalcPoint: false, //反向计算点数
            isShowProject: false,
            isStopAutoCalc: false, //是否停止自动计算点数，停止后反向计算点数也失效
            isShowAutoSeriseEng: false
        };
    },
    computed: {
        activeNoData() {
            return (!this.dialogCheckList || this.dialogCheckList.length === 0) && (!this.brainCheckList || this.brainCheckList.length === 0);
        },
        carTypeNoData() {
            return !this.checkCurrentOptions || this.checkCurrentOptions.length === 0;
        },
        // 当前智能匹配到的车型的状态文字
        selectAllText() {
            let filArr = this.checkSelectOptions.filter(f => f.BrandId === this.checkedSelect);
            if (filArr.length > 0) {
                let status = filArr[0].isAllCheck;
                return status ? '取消全选' : '全选';
            } else {
                return '全选';
            }
        }
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        let id = this.$route.query.EntpTempGoodsId;
        this.partData.EntpTempGoodsId = id;
        if (id) {
            this.pageTitle = '编辑配件信息';
            this.getConfigByCodes().then(() => {
                this.getEnterprisePart();
            });
        } else {
            this.getConfigByCodes();
        }
        let cxtObj = document.getElementById('right');
        let rightObj = cxtObj.getBoundingClientRect();
        this.boxMinHeight = rightObj.height + 'px';
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (that.$refs.selectSearise) {
                if (that.$refs.selectSearise.checkSearchVisible()) {
                    if (that.$refs.selectSearise.$refs.searchSearise) {
                        //下键
                        if (key == 40) {
                            that.$refs.selectSearise.$refs.searchSearise.keyDownFunc();
                        }
                        //右键
                        if (key == 39) {
                            that.$refs.selectSearise.$refs.searchSearise.keyRightFunc();
                        }
                        //上键
                        if (key == 38) {
                            that.$refs.selectSearise.$refs.searchSearise.keyUpFunc();
                        }
                        //上键
                        if (key == 37) {
                            that.$refs.selectSearise.$refs.searchSearise.keyLeftFunc();
                        }
                        // + 键
                        if (key === 107) {
                            that.$refs.selectSearise.$refs.searchSearise.keyEnterFunc();
                        }
                        //esc
                        if (key === 27) {
                            that.$refs.selectSearise.closeSearchDialog();
                        }
                        //enter键
                        if (key === 13) {
                            that.$refs.selectSearise.$refs.searchSearise.chooseModels();
                        }
                    }
                } else {
                    //esc
                    if (key === 27) {
                        that.dialogVisible = false;
                    }
                    //enter键
                    if (key === 13) {
                        that.$refs.selectSearise.confirmButton();
                    }
                }
            }
        },
        addSelfData() {
            this.selfData.push({
                key: '',
                value: ''
            });
        },
        delSelfData(index) {
            this.selfData.splice(index, 1);
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'zdykcsx',
                    'sptpsy',
                    'cgrcdsglsj',
                    'cgrcdsgpfj',
                    'qyzdyspsx',
                    'xzqpbmdwyx',
                    'bkbjkcs',
                    'fxjsspds',
                    'splsjpfjmrqz',
                    'hzxmxzset',
                    'lspfbgjdsbh',
                    'zscxyw'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'zdykcsx':
                                    this.partData.ExAttribute2 = result ? Number(rValue) : 0;
                                    break;
                                case 'sptpsy':
                                    this.sptpsy = result;
                                    break;
                                case 'cgrcdsglsj': //零售
                                    this.partData.MarketPricePoint = result ? Number(rValue) : 1.0;
                                    break;
                                case 'cgrcdsgpfj': //批发
                                    this.partData.PricePoint = result ? Number(rValue) : 1.0;
                                    break;
                                case 'qyzdyspsx':
                                    this.isShowPerf = result;
                                    break;
                                case 'hzxmxzset':
                                    this.isShowProject = result;
                                    break;
                                case 'zscxyw':
                                    this.isShowAutoSeriseEng = result;
                                    break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'bkbjkcs': //库存数是否允许修改
                                    this.invenCanNotBeEdit = result;
                                    break;
                                case 'fxjsspds': //反向计算点数
                                    this.isCalcPoint = result;
                                    break;
                                case 'lspfbgjdsbh':
                                    this.isStopAutoCalc = result;
                                    break;
                                case 'splsjpfjmrqz': //商品价格取整是否默认开启
                                    this.isRoundNum1 = result;
                                    this.isRoundNum2 = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        //获取库存商品信息
        getEnterprisePart() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEnterprisePart',
                    data: {
                        EntpTempGoodsId: that.partData.EntpTempGoodsId
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        let data = res.data;
                        if (data.PackageSize) {
                            let packageSize = data.PackageSize.split('*');
                            if (packageSize) {
                                data.Length = packageSize[0];
                                data.Width = packageSize[1];
                                data.Height = packageSize[2];
                            }
                        }

                        if (data.ProjectId && (!that.projectList || that.projectList.length == 0)) {
                            that.$util.getCoProjects().then(list => {
                                if (list) that.projectList = list;
                            });
                        }

                        if (data.PerfSetId && (!that.perfSetList || that.perfSetList.length == 0)) {
                            that.$util.getPerfSets().then(list => {
                                if (list) that.perfSetList = list;
                            });
                        }

                        that.partData = {
                            EntpTempGoodsId: that.partData.EntpTempGoodsId,
                            GoodCode: data.GoodCode,
                            GoodName: data.GoodName,
                            GoodDesc: data.GoodDesc,
                            MainImg: data.MainImg,
                            Price: data.Price,
                            MarketPrice: data.MarketPrice,
                            CostPrice: data.CostPrice,
                            APCode: data.APCode,
                            Size: data.Size,
                            Quality: data.Quality,
                            Brand: data.Brand,
                            Origin: data.Origin,
                            Color: data.Color,
                            Texture: data.Texture,
                            Unit: data.Unit,
                            Inventory: data.Inventory,
                            ExAttribute1: data.ExAttribute1,
                            ExAttribute2: data.ExAttribute2,
                            ExAttribute3: data.ExAttribute3,
                            ExAttribute4: data.ExAttribute4,
                            ExAttribute6: data.ExAttribute6,
                            AutoSerise: data.AutoSerise,
                            PackageSize: data.PackingSize,
                            PackingNum: data.PackingNum,
                            PictureList: [],
                            Length: data.Length,
                            Width: data.Width,
                            Height: data.Height,
                            PricePoint: data.PricePoint,
                            MarketPricePoint: data.MarketPricePoint,
                            PerfSetId: data.PerfSetId,
                            ProjectId: data.ProjectId
                        };

                        let code = data.GoodCode;
                        if (code.indexOf(',') !== -1 || code.indexOf('，') !== -1) {
                            code = data.GoodCode.split(',').join('\n');
                            code = code.split('，').join('\n');
                        }
                        that.enterGoodCode = code;
                        if (data.GoodsAttrs && data.GoodsAttrs.length > 0) {
                            that.selfData = data.GoodsAttrs;
                        }
                        //这个参数是用来判断是否有增加了库存，需要提醒去存放货物
                        that.inventoryCount = data.Inventory;

                        that.getPartOtherDatas(that.partData.EntpTempGoodsId);
                        that.getWatermarkText();
                    }
                })
                .catch(() => {})
                .finally(() => {
                    that.loading = false;
                });
        },
        getPartOtherDatas(partId) {
            if (partId) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoods/GetPartOtherDatas',
                        data: {
                            EntpTempGoodsId: partId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            let data = res.data;
                            this.uploadPictureList = data.PictureList;

                            this.partData.GoodsSeriesRs = data.GoodsSeriesRs;
                            this.partData.AllModels = data.AllModels;
                            this.warehousedCount = data.WarehousedCount;
                            this.unInInventory = this.inventoryCount - data.WarehousedCount;
                            this.minInventory = data.WarehousedCount;

                            this.getAutoSeriesByApCode('edit', data.GoodsSeriesRs).then(() => {
                                this.partData.AllModels = data.AllModels;
                                if (data.AllModels) this.dialogCheckList = data.GoodsSeriesRs;
                            });
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        // 提交表单按钮
        submitConfirm() {
            let that = this;
            if (!that.partData.AutoSerise) {
                that.$message.error('请输入适用车型');
                return;
            }
            if (that.partData.Inventory < that.warehousedCount) {
                that.$message.error('商品库存不能小于存放在仓的库存数');
                return;
            }
            if (that.isShowPerf && !that.partData.PerfSetId) {
                that.$message.error('请选择绩效属性');
                return;
            }
            if (that.isShowProject && !that.partData.ProjectId) {
                that.$message.error('请选择合作项目');
                return;
            }
            that.$refs.partData.validate(valid => {
                if (valid) {
                    this.saveBtndisabled = true;
                    if (!that.partData.Length) {
                        that.partData.Length = 0;
                    }
                    if (!that.partData.Width) {
                        that.partData.Width = 0;
                    }
                    if (!that.partData.Height) {
                        that.partData.Height = 0;
                    }
                    if (!that.partData.ExAttribute2) {
                        that.partData.ExAttribute2 = 0;
                    }
                    if (!that.partData.ExAttribute3) {
                        that.partData.ExAttribute3 = 0;
                    }

                    that.partData.PackageSize = that.partData.Length + '*' + that.partData.Width + '*' + that.partData.Height;

                    that.partData.PictureList = [];
                    if (that.uploadPictureList && that.uploadPictureList.length > 0) {
                        that.uploadPictureList = Array.from(new Set(that.uploadPictureList));
                        that.partData.PictureList = that.uploadPictureList;
                    }
                    // 提交时插入数据
                    that.partData.GoodsSeriesRs = [];
                    if (that.dialogCheckList.length > 0 || that.brainCheckList.length > 0) {
                        that.partData.GoodsSeriesRs = [...that.dialogCheckList, ...that.brainCheckList];
                    }
                    that.partData.GoodCode = '';
                    if (that.enterGoodCode) {
                        let code = that.enterGoodCode;
                        if (code.indexOf('\n') !== -1) {
                            code = code.split('\n').join(',');
                        }
                        that.partData.GoodCode = code;
                    }
                    // 处理自定义属性
                    that.partData.GoodDesc = '';
                    if (that.selfData) {
                        let list = that.selfData;
                        let fIndex = list.findIndex(i => (i.key && !i.value) || (!i.key && i.value));
                        if (fIndex > -1) {
                            that.$message.error('请将自定义属性填写完整');
                            that.saveBtndisabled = false;
                            return;
                        } else {
                            let pendList = list.filter(i => i.key && i.value);
                            if (pendList.length > 0) {
                                that.partData.GoodDesc = pendList.reduce((p, i) => {
                                    return `${p ? p + '|' : ''}${i.key}:${i.value}`;
                                }, '');
                            }
                        }
                    }
                    that.submitData();
                }
            });
        },
        // 提交表单事件
        submitData() {
            this.loading = true;
            let that = this;
            let url = '';
            let type = 0;
            let title = '';
            //传了goodsMsg是配件库的添加为库存,其余是新增或者编辑库存
            if (that.goodsMsg) url = '/api/EntpGoods/AddToInventory';
            else {
                url = '/api/EntpGoods/SaveEnterprisePart';
                if (that.partData.EntpTempGoodsId) type = 1;
                else type = 2;
            }

            if (url) {
                that.$util
                    .axiosPost({
                        url: url,
                        data: that.partData,
                        hideLoading: true
                    })
                    .then(response => {
                        that.loading = false;
                        switch (type) {
                            case 0:
                                title = '成功转为库存商品！';
                                break;
                            case 1:
                                title = '编辑商品成功！';
                                break;
                            case 2:
                                title = '添加为商品成功！';
                                break;
                        }
                        //返回的商品id
                        that.partData.EntpTempGoodsId = response.data;
                        //如果有库存变化，要提示去存放货物
                        let num = Number(that.partData.Inventory) - Number(that.inventoryCount) + Number(that.unInInventory);
                        if (num > 0) {
                            that.$confirm('监测到库存数量 ' + num * 1 + that.partData.Unit + '未存放，是否去存放货物？', title, {
                                confirmButtonText: '存放货物',
                                cancelButtonText: '取消',
                                type: 'success',
                                center: true
                            })
                                .then(() => {
                                    that.showStoreDialog();
                                })
                                .catch(() => {
                                    that.needConfirm = false;
                                    setTimeout(() => {
                                        that.$store.commit('updateNeedRefresh', true);
                                        window.history.go(-1);
                                    }, 100);
                                });
                        } else {
                            that.$util.successMsg(title);
                            that.needConfirm = false;
                            setTimeout(() => {
                                that.$store.commit('updateNeedRefresh', true);
                                window.history.go(-1);
                            }, 100);
                        }
                    })
                    .catch(() => {
                        that.loading = false;
                        that.saveBtndisabled = false;
                    });
            }
        },
        resetForm() {
            this.$refs.uploadMainFile.clearData();
            this.$refs.uploadMinorFile.clearData();
            this.partData = {};
            this.inventoryCount = 0;
        },
        showStoreDialog() {
            this.storeVisible = true;
        },
        closeStoreDialog() {
            this.storeVisible = false;
            // 关闭弹窗
            setTimeout(() => {
                this.needConfirm = false;
                this.$store.commit('updateNeedRefresh', true);
                window.history.go(-1);
            }, 100);
        },
        showGoodImgRsDialog() {
            this.goodImgRsVisible = true;
        },
        closeGoodImgRsDialog() {
            this.goodImgRsVisible = false;
        },
        upImg(imgArr) {
            if (imgArr.length > 0) {
                if (this.partData.MainImg == '') {
                    this.partData.MainImg = imgArr[0];
                    imgArr.splice(0, 1);
                }
                let arr1 = [];
                imgArr.forEach(x => {
                    if (this.uploadPictureList.indexOf(x) == -1) {
                        arr1.push(x);
                    }
                });
                let arr2 = this.uploadPictureList.concat(arr1);
                this.uploadPictureList = arr2;
            }
        },
        //成本价数值改变
        onCostPriceInput(val) {
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum1) {
                    //为什么要保留后面小数点2位，例如数据100*1.1这种情况会得到值110.00000000000001再取整会凭空多出变成111
                    let p = this.partData.CostPrice * this.partData.PricePoint;
                    this.partData.Price = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
                }
                if (this.isRoundNum2) {
                    let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                    this.partData.MarketPrice = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
                }
            }
        },
        //批发价加点改变
        onPricePiontChange() {
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum1) {
                    let p = this.partData.CostPrice * this.partData.PricePoint;
                    this.partData.Price = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
                }
            }
        },
        onPriceChange() {
            if (this.isCalcPoint && !this.isStopAutoCalc && this.partData.CostPrice && this.partData.CostPrice != 0)
                this.partData.PricePoint = (this.partData.Price / this.partData.CostPrice).toFixed(2);
        },
        onMarketPriceChange() {
            if (this.isCalcPoint && !this.isStopAutoCalc && this.partData.CostPrice && this.partData.CostPrice != 0)
                this.partData.MarketPricePoint = (this.partData.MarketPrice / this.partData.CostPrice).toFixed(2);
        },
        //市场价加点改变
        onMarketPPChange() {
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum2) {
                    let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                    this.partData.MarketPrice = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
                }
            }
        },
        //价格取整
        onIsCeilNumChange1(val) {
            this.isRoundNum1 = val;
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum1) {
                    let p = this.partData.CostPrice * this.partData.PricePoint;
                    this.partData.Price = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
                }
            } else {
                if (this.isRoundNum1) {
                    this.partData.Price = Math.ceil(this.partData.Price);
                } else {
                    this.partData.Price = this.partData.Price.toFixed(2);
                }
            }
        },
        onIsCeilNumChange2(val) {
            this.isRoundNum2 = val;
            if (!this.isStopAutoCalc) {
                if (this.isRoundNum2) {
                    let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                    this.partData.MarketPrice = Math.ceil(p.toFixed(2));
                } else {
                    this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
                }
            } else {
                if (this.isRoundNum2) {
                    this.partData.MarketPrice = Math.ceil(this.partData.MarketPrice);
                } else {
                    this.partData.MarketPrice = this.partData.MarketPrice.toFixed(2);
                }
            }
        },
        //匹配单位
        searchUnit(queryString, cb) {
            if (this.unitList && this.unitList.length > 0) {
                let list = this.unitList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getConfigData(cb);
            }
        },
        //匹配品牌
        searchBrand(queryString, cb) {
            if (this.brandList && this.brandList.length > 0) {
                let list = this.brandList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getEnterprisePartBrandList(cb);
            }
        },
        //获取品牌分类
        getEnterprisePartBrandList(cb) {
            this.$util.searchGoodsBrand().then(res => {
                this.brandList = res;
                if (cb) {
                    cb(this.brandList);
                }
            });
        },
        onAutoSeriseSelected(item) {
            this.partData.AutoSerise = item.SeriesName;
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.apCategoryList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.apCategoryList = [...this.apCategoryList, ...data];
                })
                .catch(() => {});
        },
        // 客户名称列表，加载更多
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.searchCate('');
            } else {
                if (!that.partData.ExAttribute1) {
                    that.partData.ExAttribute1 = that.cateForm.key;
                }
            }
        },
        perfVisibleChange() {
            let that = this;
            if (that.perfSetList.length == 0) {
                that.$util.getPerfSets().then(data => {
                    if (data) that.perfSetList = data;
                });
            }
        },
        projectVisibleChange() {
            let that = this;
            if (that.projectList.length == 0) {
                that.$util.getCoProjects().then(data => {
                    if (data) that.projectList = data;
                });
            }
        },
        cateClearHandle() {
            this.cateForm.key = '';
        },
        querySearchAsync(list, queryString, cb) {
            let results = queryString ? list.filter(this.createStateFilter(queryString)) : list;
            cb(results);
        },
        createStateFilter(queryString) {
            return item => {
                if (item) {
                    let reg = new RegExp(queryString);
                    return reg.test(item.Text);
                }
            };
        },
        checkexAttribute3() {
            let that = this;
            return new Promise((resolve, reject) => {
                if (that.partData.ExAttribute3 != 0 && that.partData.ExAttribute2 != 0 && that.partData.ExAttribute3 >= that.partData.ExAttribute2) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            });
        },
        //获取单位
        getConfigData(cb) {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
                if (cb) {
                    cb(this.unitList);
                }
            });
        },
        // 上传主图片成功后执行
        uploadMainSuccess(res) {
            this.partData.MainImg = res;
        },
        // 删除主图片
        handleMainRemove(file) {
            this.partData.MainImg = '';
        },
        // 上传辅助图片成功后执行
        uploadMinorSuccess(res) {
            this.uploadPictureList.push(res);
        },
        // 删除辅助图片
        handleMinorRemove(file) {
            let fileUrl = file;
            let _pictureList = this.uploadPictureList;
            for (let i = 0; i < _pictureList.length; i++) {
                if (_pictureList[i] == fileUrl) {
                    _pictureList.splice(i, 1);
                }
            }
        },
        inputBlur(event) {
            if (!event.target.value) event.target.value = 0;
        },
        inputFocus(event) {
            if (event.target.value == 0) event.target.value = '';
        },
        // 校验编码是否重复
        checkAPCode() {
            let that = this;
            return new Promise((resolve, reject) => {
                if (that.isCheckCode) {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpGoods/ValidateEnterprisePartCode',
                            data: {
                                APCode: that.partData.APCode
                            },
                            hideLoading: true
                        })
                        .then(res => {
                            if (res.data) {
                                resolve(); // 重复了
                            } else {
                                //新增库存时才匹配基础配件
                                if (that.partData.EntpTempGoodsId == '') {
                                    that.getAutoPartsByCodeOrId({
                                        Code: that.partData.APCode,
                                        Id: '',
                                        ShowLoading: false
                                    });
                                }
                                reject();
                            }
                        })
                        .catch(error => {
                            reject();
                        });
                } else {
                    reject();
                }
            });
        },
        // 切换智能车型品牌
        changeSelectList(aId) {
            let list = this.checkAllOptions;
            // 切换选框可选的列表
            this.checkCurrentOptions = list.filter(item => {
                return item.BrandId === aId;
            });
            // 切换当前选框选中集合
            this.checkedCurrentList = this.checkedAllList[aId];
            let findIndex = this.checkSelectOptions.findIndex(f => f.BrandId === this.checkedSelect);
            if (this.checkedCurrentList.length === this.checkCurrentOptions.length) {
                if (!this.checkSelectOptions[findIndex].isAllCheck) {
                    this.checkSelectOptions[findIndex].isAllCheck = true;
                }
            }
        },
        // 变更当前列表选中框
        changeCheckBox(result, row, rIndex) {
            this.checkedAllList[this.checkedSelect] = this.checkedCurrentList;
            let isAll = this.checkCurrentOptions.length === this.checkedCurrentList.length;
            // 将全选状态置为非全选
            let findIndex = this.checkSelectOptions.findIndex(f => f.BrandId === this.checkedSelect);
            if (!result && this.checkSelectOptions[findIndex].isAllCheck) {
                this.checkSelectOptions[findIndex].isAllCheck = false;
            }
            if (isAll) {
                this.checkSelectOptions[findIndex].isAllCheck = true;
            }
            this.noopsycheDataHandle();
        },
        /**
         * 智能匹配车型全选/取消全选
         */
        selectAllHandle() {
            // 没有列表不处理
            if (!this.checkedSelect) return;
            // 获取当前按钮对应列表下标
            let findIndex = this.checkSelectOptions.findIndex(f => f.BrandId === this.checkedSelect);
            let currentObj = this.checkSelectOptions[findIndex];
            // 筛选出当前列表未选中和选中的数据
            let resultObj = this.filterSingleList();
            if (resultObj.isAll) {
                // 取消全选列表
                this.checkedCurrentList = [];
                this.checkedAllList[this.checkedSelect] = [];
                this.checkSelectOptions[findIndex].isAllCheck = false;
                this.noopsycheDataHandle();
            } else {
                // 全选列表
                this.checkedCurrentList = [...resultObj.checkList, ...resultObj.notCheckList];
                this.checkedAllList[this.checkedSelect] = this.checkedCurrentList;
                this.checkSelectOptions[findIndex].isAllCheck = true;
                this.noopsycheDataHandle();
            }
        },
        // 筛选出当前智能车型列表的选中项、未选中项及判断是否全选
        filterSingleList() {
            // 根据两个列表长度判断当前列表是否已经全选
            let partList = this.checkCurrentOptions;
            let isAll = partList.length === this.checkedCurrentList.length;
            if (isAll) {
                return {
                    checkList: this.checkedCurrentList,
                    notCheckList: [],
                    isAll
                };
            } else {
                if (this.checkedCurrentList.length === 0) {
                    return {
                        checkList: [],
                        notCheckList: partList.map(m => m),
                        isAll
                    };
                }
                let checkList = [];
                let notCheckList = [];
                partList.forEach(item => {
                    let index = this.checkedCurrentList.findIndex(c => c.AutoSerieId === item.AutoSerieId);
                    if (~index) {
                        checkList.push(item);
                    } else {
                        notCheckList.push(item);
                    }
                });
                return {
                    checkList,
                    notCheckList,
                    isAll
                };
            }
        },
        // 处理智能车型展示列表
        noopsycheDataHandle() {
            if (this.partData.AllModels) {
                this.partData.AllModels = false;
                this.dialogCheckList = [];
            }
            let values = Object.values(this.checkedAllList);
            if (values) {
                var arr = values.reduce((p, r) => [...p, ...r], []);
                var newArr = [];
                arr.forEach(e => {
                    let index = this.dialogCheckList.findIndex(i => {
                        return i.AutoSerieId === e.AutoSerieId;
                    });
                    if (!~index) newArr.push(e);
                });
                this.brainCheckList = newArr;
            }
        },
        // 获取智能匹配车型
        async getAutoSeriesByApCode(type, row) {
            this.getWatermarkText();
            const {
                errcode,
                data: { Brands, Series }
            } = await this.$util.axiosPost({
                url: `/api/EntpGoods/GetAutoSeriesByApCode`,
                data: {
                    code: this.partData.APCode
                },
                hideLoading: true
            });
            if (errcode !== 0) {
                this.dialogCheckList = row;
                return;
            }
            if (Brands && Brands.length > 0) {
                // 处理下拉框展示数据
                this.checkSelectOptions = Brands.map(m => {
                    this.checkedAllList[m.BrandId] = [];
                    return {
                        isAllCheck: false,
                        ...m
                    };
                });
                // 当前下拉列表匹配关键字
                this.checkedSelect = this.checkSelectOptions[0].BrandId;
                // 处理智能匹配列表展示的数据
                this.checkCurrentOptions = Series.filter(item => {
                    return item.BrandId === this.checkedSelect;
                });
                this.checkAllOptions = Series;
            } else {
                this.checkedSelect = '';
                this.checkedAllList = {};
                this.checkSelectOptions = [];
                this.checkCurrentOptions = [];
                this.checkAllOptions = [];
            }
            // 处理编辑时展示的数据
            if (type === 'edit') {
                row.forEach(rEle => {
                    let sIndex = Series.findIndex(f => f.AutoSerieId === rEle.AutoSerieId);
                    if (~sIndex) {
                        rEle.BrandId === this.checkedSelect && this.checkedCurrentList.push(Series[sIndex]);
                        this.checkedAllList[rEle.BrandId].push(Series[sIndex]);
                    } else {
                        this.dialogCheckList.push(rEle);
                    }
                });
                if (this.checkSelectOptions.length > 0) this.checkSelectOptions[0].isAllCheck = this.checkedCurrentList.length === this.checkCurrentOptions.length;
                this.noopsycheDataHandle();
            }
        },
        // 删除添加的车型
        deleteCarTypeActive(type, index, row) {
            if (row.ModelDesc == '全车型') this.partData.AllModels = false;
            if (type === 1) {
                // this.dialogClearOptions.push(row);
                this.dialogCheckList.splice(index, 1);
            }
            if (type === 2) {
                if (this.checkedAllList && this.checkedAllList[row.BrandId]) {
                    let checkIndex = this.checkedAllList[row.BrandId].findIndex(i => i.AutoSerieId === row.AutoSerieId);
                    this.checkedAllList[row.BrandId].splice(checkIndex, 1);
                }

                this.noopsycheDataHandle();
                let ctIndex = this.checkSelectOptions.findIndex(f => f.BrandId === row.BrandId);
                if (ctIndex > -1) {
                    if (this.checkSelectOptions[ctIndex].isAllCheck) {
                        this.checkSelectOptions[ctIndex].isAllCheck = false;
                    }
                }

                let singleIndex = this.checkedCurrentList.findIndex(f => f.AutoSerieId === row.AutoSerieId);
                if (singleIndex > -1) this.checkedCurrentList.splice(singleIndex, 1);
            }
        },
        // 选择车型
        selectCarType() {
            this.dialogVisible = true;
        },
        // 把选中数据，去重后插入选择的车型列表中
        //与匹配互换码共用
        confirmSeriesButton(row) {
            if (this.partData.AllModels) {
                this.partData.AllModels = false;
                this.dialogCheckList = [];
            }

            let newChecks = [];
            if (this.dialogCheckList.length > 0) {
                for (let i = 0; i < this.dialogCheckList.length; i++) {
                    const element = this.dialogCheckList[i];

                    let index = row.findIndex(f => {
                        return f[4].split('{$}')[0] === element.AutoSerieId;
                    });

                    if (index > -1) newChecks.push(element);
                }
                this.dialogCheckList = newChecks;
            }

            row.forEach(ele => {
                let item = ele;
                //EngineType==undefined的是车型选择的操作，反之是通过发动机选择的
                if (this.dialogVisible && item.EngineType == undefined) {
                    item = {
                        AutoSerieId: ele[4].split('{$}')[0],
                        ModelDesc: ele[4].split('{$}')[1]
                    };
                }
                let index = this.dialogCheckList.findIndex(i => {
                    return i.AutoSerieId === item.AutoSerieId;
                });
                if (!~index) {
                    index = this.brainCheckList.findIndex(i => {
                        return i.AutoSerieId === item.AutoSerieId;
                    });
                    if (!~index) {
                        this.dialogCheckList.push(item);
                    }
                }
            });

            this.dialogVisible = false;
            this.changeCodeMatchVisible = false;
        },
        //全车型选择的变化
        allModelsChange(val) {
            if (val) {
                this.dialogCheckList = [{ BrandId: '全车型', AutoSerieId: '全车型', ModelDesc: '全车型' }];
                //去除智能匹配的选中
                this.brainCheckList = [];
                this.checkedCurrentList = [];
                this.checkSelectOptions.forEach(e => {
                    this.checkedAllList[e.BrandId] = [];
                    e.isAllCheck = false;
                });
            } else {
                this.dialogCheckList = [];
            }
        },
        changeCodeMatchDialog() {
            if (!this.enterGoodCode) {
                this.$message.warning('请输入互换码');
                return;
            }
            this.changeCodeMatchVisible = true;
        },
        invenChange(val) {
            if (val < this.warehousedCount) {
                this.$message.warning('商品库存不能小于存放在仓的库存数');
                return;
            }
        },
        handlePaste(e) {
            let clip = e.clipboardData.getData('Text');
            if (clip) {
                let newVal = clip.replace(/\s*/g, '').replace(/,/g, '\n').replace(/，/g, ',');
                this.enterGoodCode = this.enterGoodCode + newVal.split(',').join('\n');
            }
        },
        async searchOrigin(key) {
            if (![undefined].includes(key)) {
                this.originForm.Page = 1;
                this.originForm.stopLoad = false;
                this.originForm.key = key;
                this.originOptions = [];
            }
            if (this.originForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.originForm.key, 3, this.originForm.Page, this.originForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.originForm.stopLoad = data.length < this.originForm.Limit;
                this.originOptions = [...this.originOptions, ...data];
            }
        },
        searchOriginLoad() {
            this.originForm.Page += 1;
            this.searchOrigin();
        },
        searchGoodName(key, cb) {
            this.$util.searchPartAttr(key, 1, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = arr;
                if (cb) {
                    cb(this.goodNameOptions);
                }
            });
        },
        searchAutoSerise(key, cb) {
            this.$util.searchPartAttr(key, 2, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = arr;
                if (cb) {
                    cb(this.autoSeriseOptions);
                }
            });
        },
        getWatermarkText() {
            var watermarkText = '';
            let that = this;
            if (that.sptpsy) {
                if (that.partData.APCode != '') {
                    watermarkText = '编码：' + that.partData.APCode;
                }
                if (that.enterGoodCode != '') {
                    let gcode = that.enterGoodCode;
                    if (gcode.indexOf('\n') !== -1) {
                        gcode = gcode.split('\n')[0];
                    }
                    watermarkText += ';' + 'O  E：' + gcode;
                }
                if (that.partData.AutoSerise != '') {
                    let autos = that.partData.AutoSerise;
                    if (autos && autos.Length > 50) autos = autos.substring(0, 50);
                    watermarkText += ';' + '车型：' + autos;
                }
            }
            this.watermarkText = watermarkText;
            this.$refs.uploadMainFile.getWatermarkText(watermarkText);
            this.$refs.uploadMinorFile.getWatermarkText(watermarkText);
        },
        showLimitSet() {
            this.limitSetVisible = true;
        },
        limitSetClose(data) {
            this.limitSetVisible = false;
            if (data) {
                this.partData.LimitSets = data;
            }
        },
        calcMarketPrice() {
            if (this.isRoundNum2) {
                let p = this.partData.CostPrice * this.partData.MarketPricePoint;
                this.partData.MarketPrice = Math.ceil(p.toFixed(2));
            } else {
                this.partData.MarketPrice = (this.partData.CostPrice * this.partData.MarketPricePoint).toFixed(2);
            }
        },
        calcPrice() {
            if (this.isRoundNum1) {
                let p = this.partData.CostPrice * this.partData.PricePoint;
                this.partData.Price = Math.ceil(p.toFixed(2));
            } else {
                this.partData.Price = (this.partData.CostPrice * this.partData.PricePoint).toFixed(2);
            }
        }
    }
};
</script>

<style lang="less">
.price-point {
    .el-form-item {
        margin-bottom: 10px !important;
    }
}

.add-accessories {
    .form-line .form-item .el-form-item__label {
        white-space: nowrap;
    }

    .el-form-item {
        margin-bottom: 16px;
    }

    .section .middle textarea {
        height: 100%;
    }

    .packageSize {
        input {
            outline: none;
            height: 36px;
            line-height: 36px;
            border-radius: 5px;
            border: none;
            border: 1px solid #dcdfe6;
            text-align: center;
            width: 100px;
        }

        input:disabled {
            color: #c0c4cc;
            cursor: not-allowed;
            background-color: #f5f7fa;
        }
    }

    .dialog-s-content {
        .dialog-cascader-panel,
        .el-cascader-menu__wrap {
            height: 100%;
        }

        .el-cascader-menu__wrap {
            width: 186px;
        }

        .el-cascader-node__label {
            padding-right: 0;
        }
    }

    .row-body {
        .el-checkbox-group {
            .checkbox-item {
                display: flex;
                align-items: center;

                .el-checkbox__input {
                    margin-top: 2px;
                }
            }
        }

        .el-checkbox__label {
            white-space: normal;
        }
    }

    .cate-select {
        .el-input {
            .el-input__inner {
                height: 36px;
                line-height: 36px;
            }
        }
    }
}
</style>

<style lang="less" scoped>
.business-content-main {
    display: flex;
    flex-direction: column;
    height: 100%;

    .btns {
        // text-align: right;
        padding: 4px;
    }
}

.section {
    // flex: 1;
    // max-height: 85%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    > div {
        height: 100%;
    }

    .left {
        width: 57%;
    }

    .middle {
        width: 15%;
        padding: 0 24px;
        margin: 0 24px;
        border-left: 1px solid #dedede;
        border-right: 1px solid #dedede;
        display: flex;
        flex-direction: column;

        .title {
            padding: 16px 0;
        }

        .input-textarea {
            flex: 1;
        }
    }

    .right {
        width: 28%;

        .row-body {
            height: 26vh;
            overflow-y: scroll;
            overflow-x: hidden;

            .no-data {
                height: 200px;
                line-height: 200px;
            }
        }

        .car-type {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 24px;

            .label {
                flex-shrink: 0;
                margin-right: 16px;

                span {
                    color: #f56c6c;
                }
            }
        }

        .row-head {
            padding: 12px 16px;
            background-color: #f5f7fa;
            border-top: 1px solid #ebeef5;
            border-bottom: 1px solid #ebeef5;
            font-weight: 600;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            span {
                flex-shrink: 0;
                margin-right: 16px;
            }
        }

        .row-td {
            display: flex;
            align-items: center;
            padding: 12px 16px;
            border-bottom: 1px solid #ebeef5;
        }

        .row-model {
            width: 92%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .checkbox-item {
            width: 100%;
            padding: 12px 16px;
            border-bottom: 1px solid #ebeef5;
        }

        .el-icon-delete {
            font-size: 16px;
            color: #d9220a;
            margin-right: 16px;
            cursor: pointer;
        }
    }
}

.form-main {
    margin-top: 5px;
    width: 100%;
    display: flex;
    flex-direction: column;

    .form-line {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .form-item {
        width: 300px;

        .el-input {
            width: 200px;
        }

        .el-select {
            width: 200px;
        }
    }

    .form-item-remark {
        textarea {
            height: 100px;
        }

        .el-textarea {
            height: 100px;
        }

        .el-textarea__inner {
            height: 100px;
        }
    }
}

.autocomplete {
    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .addr {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .addr {
            color: #ddd;
        }
    }
}

.invTip {
    font-size: 12px;
    display: inline-block;
    position: absolute;
    top: 28px;
    left: 0;
    color: red;
}

.calc-btn {
    margin-left: 5px;
}
</style>
